import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { useCallback } from "react";

import React from "react";

export type CheckboxArrayProps = {
  value: string[] | null; // we store an array of strings
  item: string; // the string this checkbox represents
  disabled?: boolean;
  children?: React.ReactNode;
  onChange?: (value: string[] | null) => void;
  hidden?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
export const CheckboxArray: React.FC<CheckboxArrayProps> = ({
  value,
  item,
  disabled,
  children,
  onChange: onValueChange,
  hidden,
}: CheckboxArrayProps) => {
  const isChecked = value?.includes(item) ?? false;

  const handleChange = useCallback(
    (e: CheckboxChangeEvent) => {
      if (onValueChange !== undefined) {
        if (e.target.checked) {
          // add item if not already present
          const next = [...(value ?? []), item];
          onValueChange(next);
        } else {
          // remove item
          const next = (value ?? []).filter((v) => v !== item);
          onValueChange(next.length > 0 ? next : []);
        }
      }
    },
    [item, value, onValueChange]
  );

  return (
    <Checkbox
      onChange={handleChange}
      checked={isChecked}
      disabled={disabled}
      style={{ display: hidden === true ? "none" : "auto" }}
    >
      {children}
    </Checkbox>
  );
};
